import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ApplicationController } from '@core/application';
import { AppConfigService } from '@core/services';
import { FeatureType, UserController } from '@core/user';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, map, Observable } from 'rxjs';

@UntilDestroy()
export class BaseGuard {

  protected readonly _router = inject(Router);
  protected readonly _appController = inject(ApplicationController);
  protected readonly _appConfigService = inject(AppConfigService);
  protected readonly _userController = inject(UserController);

  constructor() { }

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this._userController.hasUser$
      .pipe(
        untilDestroyed(this),
        filter(hasUser => !!hasUser),
        map(this._checkCanActivate.bind(this))
      );
  }

  protected _checkCanActivate() { return false; }

  protected _redirectToBaseRoute() {
    this._router.navigate([this._appConfigService.get('baseRouteRedirect')]);
  }

  protected _hasFeature(feature: FeatureType): boolean {
    return this._userController.hasFeature(feature);
  }
}
